import { IconContent } from '@icons';

export const padlockClosed: IconContent = {
    md: '<path fill-rule="evenodd" d="M12 5a2.5 2.5 0 0 0-2.5 2.5V11h5V7.5A2.5 2.5 0 0 0 12 5ZM8.5 7.5V11H6v9h12v-9h-2.5V7.5a3.5 3.5 0 1 0-7 0ZM7 12h10v7H7v-7Zm5.5 4.914V14h-1v2.914h1Z" />',
};
